import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import { auth, firestore } from '@/plugins/firebase'
import firebase from '@/plugins/firebase'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    login_user: null,
    // テスト用
    //login_user: { displayName: 'Test Taro', photoURL: '' },
    drawer: false,
    // 算命カレンダー用
    user_birthday: {
      year: '',
      month: '',
      day: '',
      sex: '',
    },
    user_meishiki: {
      santyu: {
        day1: '',
        day2: '',
        month1: '',
        month2: '',
        year1: '',
        year2: '',
        etoDayIndex: '',
        etoMonthIndex: '',
        etoYearIndex: '',
      },
    },
    user_info: {
      shimei: '',
      shimeiKana: '',
      mail: '',
      password: '',
      selectedJobItem: '経営者・役員',
      selectedUsecase: '事業の経営判断',
      learn: '',
      receiveMail: 'YES',
    },
    eto60: {
      0: '癸亥', // 割算の便宜上、60と同等
      1: '甲子',
      2: '乙丑',
      3: '丙寅',
      4: '丁卯',
      5: '戊辰',
      6: '己巳',
      7: '庚午',
      8: '辛未',
      9: '壬申',
      10: '癸酉',
      11: '甲戌',
      12: '乙亥',
      13: '丙子',
      14: '丁丑',
      15: '戊寅',
      16: '己卯',
      17: '庚辰',
      18: '辛巳',
      19: '壬午',
      20: '癸未',
      21: '甲申',
      22: '乙酉',
      23: '丙戌',
      24: '丁亥',
      25: '戊子',
      26: '己丑',
      27: '庚寅',
      28: '辛卯',
      29: '壬辰',
      30: '癸巳',
      31: '甲午',
      32: '乙未',
      33: '丙申',
      34: '丁酉',
      35: '戊戌',
      36: '己亥',
      37: '庚子',
      38: '辛丑',
      39: '壬寅',
      40: '癸卯',
      41: '甲辰',
      42: '乙巳',
      43: '丙午',
      44: '丁未',
      45: '戊申',
      46: '己酉',
      47: '庚戌',
      48: '辛亥',
      49: '壬子',
      50: '癸丑',
      51: '甲寅',
      52: '乙卯',
      53: '丙辰',
      54: '丁巳',
      55: '戊午',
      56: '己未',
      57: '庚申',
      58: '辛酉',
      59: '壬戌',
      60: '癸亥',
    },
    eto_basedate_day_index: 11,
    errorMessage: '',
  },
  mutations: {
    setLoginUser(state, user) {
      state.login_user = user
      // ログインに成功した場合、ユーザ名を設定
      state.user_info.shimei = user ? user.displayName : ''
      state.user_info.mail = user ? user.email : ''
    },
    deleteLoginUser(state) {
      state.login_user = null
      state.user_birthday = {
        year: '',
        month: '',
        day: '',
        sex: '',
      }
      state.user_meishiki = {
        santyu: {
          day1: '',
          day2: '',
          month1: '',
          month2: '',
          year1: '',
          year2: '',
          etoDayIndex: '',
          etoMonthIndex: '',
          etoYearIndex: '',
        },
      }
      state.user_info = {
        shimei: '',
        shimeiKana: '',
        mail: '',
        selectedJobItem: '経営者・役員',
        selectedUsecase: '事業の経営判断',
        learn: '',
        receiveMail: 'YES',
      }
    },
    toggleSideMenu(state) {
      state.drawer = !state.drawer
    },
    userMeishiki(state, { userMeishiki, birthday, userInfo }) {
      state.user_meishiki = userMeishiki
      state.user_birthday = birthday
      state.user_info = userInfo
      router.push('calendar')
    },
    userMeishikiNotExists(state) {
      state.user_meishiki = {
        santyu: {
          day1: '',
          day2: '',
          month1: '',
          month2: '',
          year1: '',
          year2: '',
          etoDayIndex: '',
          etoMonthIndex: '',
          etoYearIndex: '',
        },
      }
      state.user_birthday = {
        year: '',
        month: '',
        day: '',
        sex: '',
      }
      router.push('register')
    },
    setErrorMessage(state, errorMessage) {
      state.errorMessage = errorMessage
    },
  },
  actions: {
    setLoginUser({ commit }, user) {
      commit('setLoginUser', user)
    },
    deleteLoginUser({ commit }) {
      commit('deleteLoginUser')
    },
    logout() {
      auth.signOut()
    },
    async registerUserByEmailAndPassword({ commit }, { registerUserInfo }) {
      // Emailとパスワードでユーザ作成
      await auth
        .createUserWithEmailAndPassword(
          registerUserInfo.email,
          registerUserInfo.password
        )
      // eslint-disable-next-line no-unused-vars
        .then(async (userCredential) => {
          //console.debug('ユーザ登録', userCredential)
          await auth
            .signInWithEmailAndPassword(
              registerUserInfo.email,
              registerUserInfo.password
            )
            .then((userCredential) => {
              //console.log('signInWithEmailAndPassword')
              let user = userCredential.user
              commit('setLoginUser', user)
            })
          // eslint-disable-next-line no-unused-vars
            .catch((error) => {
              //console.log(error)
            })
        })
      // eslint-disable-next-line no-unused-vars
        .catch((error) => {
          //console.log(error)
          commit('setErrorMessage', 'メールアドレスは既に登録されています。')
          throw error
        })
    },
    loginUserByEmailAndPassword({ dispatch, commit }, loginUserInfo) {
      // Emailとパスワードでログイン
      console.log('loginUserByEmailAndPassword')
      auth.signInWithEmailAndPassword(
        loginUserInfo.email,
        loginUserInfo.password
      )
        .then((userCredential) => {
          console.log('signInWithEmailAndPassword userCredential', userCredential)
          let user = userCredential.user
          commit('setLoginUser', user)
          dispatch('fetchUserMeishiki')
        })
      // eslint-disable-next-line no-unused-vars
        .catch((error) => {
          //console.log(error)
          commit('setErrorMessage', 'メールアドレスが登録されていないか、パスワード誤りです。')
        })
    },
    loginGoogle() {
      router.push('loading')
      const google_auth_provider = new firebase.auth.GoogleAuthProvider()
      auth.setPersistence('none').then(async () => {
        await auth.signInWithPopup(google_auth_provider)
      })
    },
    loginFacebook() {
      router.push('loading')
      const facebook_auth_provider = new firebase.auth.FacebookAuthProvider()
      facebook_auth_provider.addScope('email')
      auth.setPersistence('none').then(async () => {
        await auth.signInWithPopup(facebook_auth_provider)
      })
    },
    toggleSideMenu({ commit }) {
      commit('toggleSideMenu')
    },
    fetchUserMeishiki({ getters, commit }) {
      //console.log('##store fetchUserMeishiki')
      firestore
        .collection('users')
        .doc(getters.uid)
        .get()
        .then((doc) => {
          if (doc.exists) {
            const userInfoDoc = {
              selectedJobItem: doc.data()['job'],
              learn: doc.data()['learn'],
              mail: doc.data()['mail'],
              receiveMail: doc.data()['receiveMail'],
              shimei: doc.data()['shimei'],
              shimeiKana: doc.data()['shimeiKana'],
              selectedUsecase: doc.data()['usecase'],
            }
            commit('userMeishiki', {
              userMeishiki: doc.data()['meishiki'],
              birthday: doc.data()['birthday'],
              userInfo: userInfoDoc,
            })
          } else {
            commit('userMeishikiNotExists')
          }
        })
    },
    registerUserMeishiki({ commit }, { userMeishiki, birthday, userInfo }) {
      commit('userMeishiki', { userMeishiki, birthday, userInfo })
    },
    registerUserInfo({ commit }) {
      commit('userInfo', {})
    },
    setErrorMessage({ commit }, errorMessage) {
      commit('setErrorMessage', errorMessage)
    },
  },
  getters: {
    isRegisteredUser: (state) => state.login_user != null,
    userName: (state) =>
      state.login_user ? state.login_user.displayName : '',
    photoURL: (state) =>
      state.login_user ? state.login_user.photoURL : '',
    uid: (state) => state.login_user ? state.login_user.uid : null,
    etoDayIndex: (state) => (date) => {
      const nowDay = new Date(date + 'T00:00:00') // 現在の年月日までを取得することor切り捨て
      const baseDay = new Date('1900/01/01')
      const termDay = (nowDay - baseDay) / 86400000 | 0 // 86,400,000ミリ秒 = 1日
      // safari対応 Dateオブジェクトの扱いが違う?
      return (state.eto_basedate_day_index + termDay) % 60 // 11は基準日1900/01/01のetoDayIndex仮値
    },
  },
  modules: {},
})
